import { ReactNode } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../constants/i18n"

import { CampaignSelector, CampaignSelectorProps } from "./CampaignSelector"
import * as Styled from "./CampaignSelector.styled"

interface CampaignSelectorMobileProps extends Omit<CampaignSelectorProps, "onClose"> {
    currentSubmenu?: {
        label: string
        children?: {
            component: ReactNode
            props?: Record<string, any>
        }
    }
    onClose: (confirmed: boolean) => void
    onCancel: () => void
}

export const CampaignSelectorMobile = (props: CampaignSelectorMobileProps) => {

    const {
        currentSubmenu,
        onClose,
        onCancel,
        ...CampaignSelectorProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    return <Styled.BottomSheet
        displayPuller
        onOpen={() => undefinedFunctionWarning("onOpen")}
        open={true}
        onClose={() => onClose(false)}
    >
        <Styled.Title variant="Desktop & Mobile/Heading/H1">{currentSubmenu?.label}</Styled.Title>
        <Styled.BottomSheetContent>
            {currentSubmenu?.children?.component}
        </Styled.BottomSheetContent>
        <CampaignSelector {...CampaignSelectorProps} onClose={() => onClose(false)} />
        <Styled.ButtonsContainer>
            <Styled.BottomSheetButton
                variant="tertiary"
                onClick={() => {
                    onCancel()
                    onClose(false)
                }}
            >
                {t(I18N_NAMESPACE, "components.campaignSelector.cancel")}
            </Styled.BottomSheetButton>
            <Styled.BottomSheetButton onClick={() => {
                onClose(true)
            }}>
                {t(I18N_NAMESPACE, "components.campaignSelector.apply")}
            </Styled.BottomSheetButton>
        </Styled.ButtonsContainer>
    </Styled.BottomSheet>
}